<template>
    <div class="min-h-[100vh] flex flex-col sm:justify-center items-center sm:pt-0 bg-gray-150 px-4 md:px-0">
        <div>
            <slot name="logo" />
        </div>

        <div class="w-full sm:max-w-md my-3 p-4 md:p-6 bg-white shadow-md overflow-hidden rounded-lg">
            <slot />
        </div>

        <div>
            <slot name="message"></slot>
        </div>
    </div>
</template>
